<template>
    <!-- Status Divider -->
    <divider-generic
    icon="info"
    :applyBorder="false"
    :title="t('approvals.operators.operatorDetails.statusTitle')"/>
    <!-- Status -->
    <text-block-generic
    :params="{ label: t('approvals.operators.operatorDetails.statusLabel'), content: operatorDetails.status?.operatorStatusDescription }"/>
    <!-- Condition -->
    <text-block-generic
    :params="{
        label: t('approvals.operators.operatorDetails.conditionLabel'),
        content: operatorDetails.condition ? operatorDetails.condition : ' '
    }"
    :icon="operatorDetails.condition ? 'clock' : iconHandler(operatorDetails.status?.operatorStatusValue)"
    :colorIconPreset="operatorDetails.condition ? 'warning' : classesHandler(operatorDetails.status?.operatorStatusValue)"/>
    <!-- Block Motive -->
    <text-block-generic
    v-if="operatorDetails.blockMotive"
    :params="{ label: t('approvals.operators.operatorDetails.blockMotiveLabel'), content: operatorDetails.blockMotive }"/>
    <!-- Created/Edited By -->
    <text-block-generic
    :params="{
        label: operatorDetails.condition ? t('approvals.operators.operatorDetails.editedByLabel') : t('approvals.operators.operatorDetails.createdByLabel'),
        content: operatorDetails.condition ? (operatorDetails.updatedBy?.name || '-') : (operatorDetails.createdBy?.name || '-')
    }"/>
    <!-- Last Update -->
    <text-block-generic
    :params="{
        label: t('approvals.operators.operatorDetails.lastUpdateLabel'),
        content: getDateWithTime(operatorDetails.lastUpdate),
        classes: 'capitalize'
    }"/>
    <!-- Channel -->
    <text-block-generic
    :params="{ label: t('approvals.operators.operatorDetails.channelLabel'), content: operatorDetails.channel ? operatorDetails.channel.name : '-' }"/>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Vue & Helpers */
import { iconHandler, classesHandler } from '@/assets/scripts/mappers/operators'
import { getDateWithTime } from '@/assets/scripts/dateBuilders'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
    operatorDetails: Object
})
</script>

<style lang="scss" scoped>
</style>
